import { ElementRef, WritableSignal } from '@angular/core';

type OptionalSignal<T> = WritableSignal<T> | undefined;

export function isOutsideElementClick(
  elementRef: ElementRef,

  event: Event,
): boolean {
  return !elementRef.nativeElement.contains(event.target);
}

export function closeDropdown(
  isOpen: WritableSignal<boolean>,

  searchTerm?: OptionalSignal<string>,
): void {
  isOpen.set(false);

  searchTerm?.set('');
}

export function closeDropdownOnOutsideClick(
  elementRef: ElementRef,

  event: Event,

  isOpen: WritableSignal<boolean>,

  searchTerm?: OptionalSignal<string>,
): void {
  if (isOutsideElementClick(elementRef, event)) {
    closeDropdown(isOpen, searchTerm);
  }
}

export function toggleDropdown(
  isOpen: WritableSignal<boolean>,

  searchTerm?: OptionalSignal<string>,
): void {
  isOpen.update((currentIsOpen) => {
    const nextIsOpen = !currentIsOpen;

    if (!nextIsOpen) {
      searchTerm?.set('');
    }

    return nextIsOpen;
  });
}

export function stopEvent(event: Event): void {
  event.stopPropagation();
}
